import React from 'react'

import "./Footer.css";

export const Footer = () => {
    return (
        <footer>
            <p>Copyright: Bubble by Nor. x West Designs</p>
            <p>Explore more of bubble by downloading the app</p>
        </footer>
    )
}
